<template>
    <div
        v-if="formPergunta.datahoradel == undefined || formPergunta.datahoradel == null"
        class="campo"
        :class="{
            'campo-not-expanded': !expanded,
            'not-first': index,
            'invalid': !getValidade() && expanded,
        }"
    >
        <div class="not-expanded" v-if="!expanded">
            <!-- <div class="p-handle">
                <svg class="svg-icons">
                    <use :xlink:href="require('@/assets/img/icons/drag.svg') + '#layer'"></use>
                </svg>
            </div> -->
            <div class="nome ml-2" :class="{ 'invalid': !getValidade() }" tabindex="0" @focus="expand()">
                {{
                    !isNull(formPergunta.descricao)
                        ? cutString(formPergunta.descricao, 70)
                        : $t('pergunta-sem-titulo')
                }}
            </div>
            <div @click="expanded = !expanded" class="clicable">
                <b-icon icon="plus" class="silver" />
            </div>
        </div>
        <div class="expanded" ref="expanded" v-else tabindex="0">
            <div class="nome">
                <span>{{ $t('titulo-da-pergunta') }}</span>
                <div @click="expanded = !expanded" class="clicable">
                    <b-icon icon="minus" class="silver" />
                </div>
            </div>
            <div class="campos">
                <div class="titulo-campo">
                    <v-textarea
                        ref="titulo-campo"
                        v-model="formPergunta.descricao"
                        :maxlength="150"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="isNull(formPergunta.descricao)"
                        :placeholder="'titulo-campo-placeholder'"
                        :rows="2"
                        :maxRows="3"
                        :disableTransform="true"
                        :onKeyUp="emitUpdates"
                        :focusEvt="() => (expanded = true)"
                    />
                </div>
                <div class="campo-tipo">
                    <vss-select ref="tipoSelect" @input="updateTipo" v-model="tipo" :options="tipos" no-clearfix
                        placeholder="tipo-do-campo" title="tipo-do-campo" :displayFlex="false" :mlLabelsTitle="true">
                        <template #option="{ option }">
                            <svg class="svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/' + option.svg + '.svg') +
                                        '#layer'
                                    "
                                ></use>
                            </svg>
                            {{ $t(option.label) }}
                        </template>
                    </vss-select>
                </div>
                <div
                    class="respostas"
                    v-if="
                        ['TEXT', 'MULTITEXT', 'INTEGER', 'DECIMAL', 'PERCENT'].indexOf(
                            this.formPergunta.item_tipo
                        ) > -1
                    "
                >
                    <input
                        @keyup="emitUpdates()"
                        ref="resposta"
                        @focus="expanded = true"
                        v-model="formPergunta.formRespostaItemList[0].descricao"
                        type="text"
                        v-bind:placeholder="
                            $t('resposta-campo-placeholder-' + this.formPergunta.item_tipo)
                        "
                        maxlength="255"
                    />
                </div>
                <div
                    class="respostas"
                    v-if="
                        ['SWITCH', 'RADIO', 'CHECKBOX', 'COMBOBOX'].indexOf(
                            formPergunta.item_tipo
                        ) > -1
                    "
                >
                    <div
                        v-for="(formRespostaItem, i) in formPergunta.formRespostaItemList"
                        :key="i"
                        class="resposta"
                    >
                        <div v-if="formRespostaItem.datahoradel == null || formRespostaItem.datahoradel == undefined">
                            <b-icon
                                class="resposta-icon"
                                icon="toggle-switch-off"
                                size="is-medium"
                                v-if="formPergunta.item_tipo == 'SWITCH'"
                            />
                            <b-icon
                                class="resposta-icon"
                                icon="checkbox-blank-outline"
                                v-if="formPergunta.item_tipo == 'CHECKBOX'"
                            />
                            <b-icon
                                class="resposta-icon"
                                icon="radiobox-blank"
                                v-if="formPergunta.item_tipo == 'RADIO'"
                            />
                            <input
                                class="check-input"
                                @keyup="emitUpdates()"
                                v-model="formRespostaItem.descricao"
                                @focus="expanded = true"
                                :ref="`input_${index}_${i}`"
                                type="text"
                                :placeholder="$t('opcao-campo-placeholder') + ' ' + (i + 1)"
                                maxlength="255"
                                required
                            />
                            <svg
                                v-if="(permissao.delete)"
                                class="svg-icons"
                                @click="excluirRespostaModal(formRespostaItem)"
                                @focus="expanded = true"
                            >
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/delete.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                        </div>
                    </div>
                    <div class="resposta-add">
                        <b-icon
                            class="resposta-icon pt-1"
                            icon="toggle-switch-off"
                            size="is-medium"
                            v-if="formPergunta.item_tipo == 'SWITCH'"
                        />
                        <b-icon
                            class="resposta-icon"
                            icon="checkbox-blank-outline"
                            v-if="formPergunta.item_tipo == 'CHECKBOX'"
                        />
                        <b-icon
                            class="resposta-icon"
                            icon="radiobox-blank"
                            v-if="formPergunta.item_tipo == 'RADIO'"
                        />
                        <input
                            class="check-input"
                            @keyup="emitUpdates()"
                            ref="respostaField"
                            @focus="addField()"
                            type="text"
                            :placeholder="$t('opcao-campo-placeholder')"
                            maxlength="0"
                        />
                    </div>
                </div>
            </div>
            <div class="opcoes">
                <div class="buttons">
                    <div>
                        <svg class="svg-icons" @click="copiarPergunta()" @focus="expanded = true">
                            <use
                                :xlink:href="
                                    require('@/assets/img/icons/content-copy.svg') + '#layer'
                                "
                            ></use>
                        </svg>
                    </div>
                    <div>
                        <svg
                            v-if="(permissao.delete)"
                            class="svg-icons"
                            @click="excluirPerguntaModal()"
                            @focus="expanded = true"
                        >
                            <use
                                :xlink:href="require('@/assets/img/icons/delete.svg') + '#layer'"
                            ></use>
                        </svg>
                    </div>
                </div>
                <fSwitch
                    :value="`pergunta_${this.index}`"
                    :focus="() => (expanded = true)"
                    :text="$t('campo-obrigatorio')"
                    :checked="formPergunta.obrigatorio"
                    :onChange="changeObriga"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FormRespostaItemService from "@/services/FormRespostaItemService.js";
import fSwitch from "@/components/shared/form/Switch.vue";
import SelectBox from "@/components/shared/form/SelectBox.vue";

export default {
    props: {
        formPergunta: {
            default: {},
        },
        expandir: {
            default: false,
        },
        contexto: {
            type: String,
            default: '',
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        permissao: {
            type: Object,
            default: () => {}
        },
        index: Number,
        canSelectTipo: false,
    },
    data() {
        return {
            texttypemenu: false,
            expanded: this.expandir,
            tipo: null,

            tipos: [
                {
                    index: 0,
                    class: 'fas fa-align-right',
                    svg: 'text-short',
                    desc: 'Área de Texto Curto',
                    label: 'area-texto-curto',
                    type: 'TEXT',
                },
                {
                    index: 1,
                    class: 'fas fa-align-justify',
                    svg: 'text-subject',
                    desc: 'Área de Texto Longo',
                    label: 'area-texto-longo',
                    type: 'MULTITEXT',
                },
                {
                    index: 2,
                    class: 'fas fa-list-ol',
                    svg: 'text-short',
                    desc: 'Campo de Número',
                    label: 'campo-numero',
                    type: 'INTEGER',
                },
                {
                    index: 3,
                    class: 'fas fa-dollar-sign',
                    svg: 'currency-usd',
                    desc: 'Campo de Moeda',
                    label: 'campo-moeda',
                    type: 'DECIMAL',
                },
                {
                    index: 4,
                    class: 'fas fa-percent',
                    svg: 'percent',
                    desc: 'Campo de Porcentagem',
                    label: 'campo-porcentagem',
                    type: 'PERCENT',
                },
                // {
                //     index: 5,
                //     class: 'fas fa-list-ol',
                //     svg: 'text-short',
                //     desc: 'Numeração Automática',
                // },
                {
                    index: 6,
                    class: 'fas fa-list-ol',
                    svg: 'text-short',
                    desc: 'Disjuntor',
                    label: 'disjuntor',
                    type: 'SWITCH',
                },
                // {
                //     index: 7,
                //     class: 'fas fa-stop',
                //     svg: 'checkbox-blank',
                //     desc: 'Caixa de Solução',
                //     type: 'SWITCH'
                // },
                {
                    index: 8,
                    class: 'fas fa-calendar',
                    svg: 'calendar-clock',
                    desc: 'Campo de Data e Hora',
                    label: 'campo-data-hora',
                    type: 'DATETIME',
                },
                {
                    index: 9,
                    class: 'far fa-calendar-alt',
                    svg: 'calendar',
                    desc: 'Calendário',
                    label: 'calendario',
                    type: 'DATE',
                },
                {
                    index: 10,
                    class: 'fas fa-dot-circle',
                    svg: 'radiobox-marked',
                    desc: 'Multipla Escolha',
                    label: 'multipla-escolha',
                    type: 'RADIO',
                },
                {
                    index: 11,
                    class: 'fas fa-check-square',
                    svg: 'checkbox-marked',
                    desc: 'Lista de Opções',
                    label: 'lista-opcoes',
                    type: 'CHECKBOX',
                },
                {
                    index: 12,
                    class: 'fas fa-chevron-circle-down',
                    svg: 'menu-down',
                    desc: 'Combo box',
                    label: 'combo-box',
                    type: 'COMBOBOX',
                },
            ],
            tipostextnum: 0,
            selectedIndex: 0,
            // ConfiguraCampos.vue
            confCampos: this.$parent,
            tipoSelectHasListener: false,
            service: new FormRespostaItemService(this.$http, this.$router),
        };
    },
    created() {
        this.tipostextnum = this.tipos.length;
        let descs = this.tipos.filter(
            (t) => this.formPergunta && t.type == this.formPergunta.item_tipo
        )[0];

        this.tipo = this.formPergunta ? 
            {
                id: this.formPergunta.item_tipo,
                desc: descs ? descs.desc : '',
                label: descs ? descs.label : '',
                type: this.formPergunta.item_tipo,
            } : 
            {
                svg: 'text-short',
                desc: 'Área de Texto Curto',
                label: 'area-text-curto',
                type: 'TEXT',
            };
    },
    components: {
        fSwitch,
        SelectBox,
    },
    methods: {
        openTextOptions() {
            this.texttypemenu = !this.texttypemenu;
        },
        setSelectedItem(index) {
            this.selectedIndex = index;
        },
        onDrop: function (dropResult) {
            this.items = applyDrag(this.items, dropResult);
        },
        updateTipo(tipo) {
            // Inicializa o formPergunta caso nao exista
            this.formPergunta = this.formPergunta || { formRespostaItemList: [] };

            // Update formRespostaItemList quando muda o tipo da pergunta
            this.formPergunta.formRespostaItemList = [{
                datahorainc: null,
                datahoraalt: null,
                id_form_pergunta: null,
                descricao: null,
                habilita_foto: 0,
                situacao: 1,
                datahoradel: null,
            }];

            if (tipo) {
                const { type, desc, label } = tipo;
                this.formPergunta.item_tipo = type;
                this.tipo = { id: type, desc, type, label };
            }
        },
        addField() {
            this.expanded = true;
            this.formPergunta.formRespostaItemList.push({});
            this.emitUpdates();
            setTimeout(() => {
                let i = this.formPergunta.formRespostaItemList.length - 1;
                this.$refs[`input_${this.index}_${i}`][0].focus();
            }, 100);
        },
        copiarPergunta() {
            this.confCampos.$emit('copiar-pergunta', this.index);
        },
        excluirPergunta() {
            this.confCampos.$emit('excluir-pergunta', this.index);
        },
        excluirPerguntaModal() {
            this.$root.confirm({
                message: 
                    this.$t('msg-confirmacao-exclusao-pergunta-n', {
                        n: !this.isNull(this.formPergunta.descricao)
                            ? this.formPergunta.descricao
                            : this.$t('pergunta-sem-titulo') 
                    }),
                onConfirm: this.excluirPergunta,
            });
        },
        excluirRespostaModal(item) {
            this.$root.confirm({
                message: 
                    this.$t('msg-confirmacao-exclusao-n', {
                        n: !this.isNull(item.descricao) 
                            ? item.descricao
                            : this.$t('resposta-sem-titulo')
                    }),
                onConfirm: (_) => {
                    this.excluirResposta(item);
                },
            });
        },
        excluirResposta(item) {
            const del = this.formPergunta.formRespostaItemList.indexOf(item);
            if (del >= 0) {
                if (this.isNull(item.id) || item.id == 0) {
                    this.formPergunta.formRespostaItemList.splice(del, 1);
                } else {
                    item.datahoradel = new Date();
                }
                this.$emit('isChanged', true);
                this.$forceUpdate();
            }
        },
        changeObriga(e) {
            this.formPergunta.obrigatorio = e.target.checked ? 1 : 0;
            this.emitUpdates();
        },
        expand() {
            this.expanded = true;
            this.$nextTick(() => this.$refs['titulo-campo'].onFocus());
        },
        emitUpdates() {
            this.confCampos.$emit('update-pergunta', this.formPergunta, this.index);
        },
        getValidade() {
            let valid = true;

            if (this.isNull(this.formPergunta.descricao)) {
                valid = false;
            }

            if (['SWITCH', 'RADIO', 'CHECKBOX', 'COMBOBOX'].includes(this.formPergunta.item_tipo)) {
                if (this.formPergunta.formRespostaItemList.length == 0) {
                    valid = false;
                } else {
                    this.formPergunta.formRespostaItemList.forEach((formRespostaItem) => {
                        if (this.isNull(formRespostaItem.descricao)) {
                            valid = false;
                        }
                    });
                }
            }
            return valid;
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return option.desc;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.silver {
    color: #777;
}
.campo {
    position: relative;
    padding: 15px;
    background: $sovis-white;
    // box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.08);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-bottom: 10px;
    border: 1px solid $table-border;


    &:first-child {
        border-radius: 6px 6px 0 0;
    }
    &:last-child {
        border-radius: 0 0 6px 6px;
    }
    &:not(:first-child) {
        margin: 10px 0;
    }

    &.campo-not-expanded {
        box-sizing: border-box;
        box-shadow: none;
        margin-bottom: 0;
        margin-top: 0;
        padding: 0;
    }

    &.invalid {
        border: 1px solid $red-alert;
    }

    .not-expanded:focus,
    .expanded:focus,
    .not-expanded:focus,
    .expanded:focus {
        outline: none;
    }

    .not-expanded {
        display: flex;
        align-items: center;
        min-height: 40px;
        padding-right: 5px;

        .p-handle {
            display: flex;
            align-items: center;
            width: 20px;
            height: 100%;
            margin: 0 5px;
            cursor: move;

            svg {
                transform: rotate(90deg);
            }
        }

        & > div {
            display: inline-block;

            >h4 {
                cursor: pointer;
            }
        }

        .nome {
            display: inline-flex;
            align-items: center;
            width: 100%;
            height: 100%;
            font-size: 14px;
            color: $primary-color;
            font-weight: 600;
            text-transform: uppercase;
            cursor: pointer;

            &.invalid {
                color: $red-alert;
            }
        }
    }

    .expanded {
        .nome {
            display: flex;
            justify-content: space-between;
            color: $primary-color;
            font-weight: 600;
            margin-bottom: 5px;

            .minimize {
                cursor: pointer;
            }
        }
    }

    .opcoes {
        margin-top: 15px;
        padding: 15px 10px 5px 10px;
        border-top: 0.5px solid $table-border;
        flex: 0 1 auto;
        display: flex;
        justify-content: flex-start;

        >.buttons {
            border-right: 0.5px solid $light-gray-color;
            display: flex;

            &:not(:last-child) {
                margin-bottom: 0 !important;
            }

            >div {
                height: 30px;
                width: 30px;
                margin-right: 20px;

                svg {
                    cursor: pointer;
                    fill: $darker-gray-color;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .campos {
        flex: 1 1 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        >.titulo-campo {
            width: 67%;
            margin-right: 3%;
        }

        >.campo-tipo {
            width: 30%;

            .dropdown-toggle {
                height: 35px;
                // padding: 0;
            }
        }

        >.respostas {
            width: 100%;
            margin-top: 10px;

            input {
                outline: none;
                border: none;
                width: 67%;
                padding-bottom: 0;
                padding-left: 5px;
                font-weight: 200;
                color: $darker-gray-color;
                border-bottom: 1px dotted $light-gray-color;

                &:focus {
                    border-bottom: 1px solid $primary-color;
                }

                &.check-input {
                    width: calc(64%) !important;
                }
            }

            .resposta,
            .resposta-add {
                display: flex;
                align-items: center;

                input {
                    outline: none;
                    border: none;
                    width: 67%;
                    padding-bottom: 0;
                    padding-left: 5px;
                    font-weight: 200;
                    color: $darker-gray-color;
                    border-bottom: 1px dotted $light-gray-color;

                    &:focus {
                        border-bottom: 1px solid $primary-color;
                    }

                    &.check-input {
                        width: calc(64%) !important;
                    }

                    &[type='checkbox'],
                    &[type='radio'] {
                        opacity: 0;
                    }
                }

                svg {
                    cursor: pointer;
                }

                .resposta-icon {
                    color: $text-color;
                }

                .campo-resposta {
                    display: inline-block;
                }

                .check-box {
                    .checkmark {
                        position: inherit;
                        display: inline-flex;
                        top: 0;
                        right: 0;
                        height: 16px;
                        width: 16px;
                        border: 2px solid $primary-color-hover;
                        margin-top: 5px;
                        margin-right: 10px;
                        border-radius: 3px;
                    }
                }

                .radio-box .checkmark {
                    top: -5px;
                }

                &:not(:first-child) {
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
